module.exports = __webpack_public_path__ + "teg/media/tegLogo.e9aa4cb1.jpg";